import styled from 'styled-components'

export const SelectPaymentMethodCategoryStepFooterStyled = styled.div`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};

  padding: ${(props) => props.theme.space.large}
    ${(props) => props.theme.space.medium};

  border-top: 1px solid ${(props) => props.theme.colors.content.border};
`
